import React from 'react';
import { ItineraryLeg as ItineraryLegModel } from 'acscp/store';
import style from './itineraryLegDetails.module.scss';
import { AircraftDetails } from './aircraftDetails';
import { Airports } from './airports';
import { PassengerDetails } from './passengerDetails';
import { Catering } from './catering';
import { OtherInformation } from './otherInfo';
import { OptionalServices } from './optionalServices';
import { CollapsableSet } from '../common/collapsable';
import { ExpandAll } from './collapsableSections';
import { Schedule } from './schedule';
import { CrewMembersDetails } from './crewMembersDetails';

interface ItineraryLegDetailsProps {
    itineraryLeg: ItineraryLegModel;
    isLongStandingCustomer: boolean;
}

export const ItineraryLegDetails: React.SFC<ItineraryLegDetailsProps> = ({itineraryLeg, isLongStandingCustomer}) => {
    return (
        <CollapsableSet ExpandAll={ExpandAll}>
            <Schedule
                legs={[itineraryLeg.leg]}
                airports={itineraryLeg.airports}
                displayVisaMessage={false}
                className={style.MobileOnly}
            />
            <AircraftDetails
                aircraft={itineraryLeg.aircraft}
                flightNumber={itineraryLeg.flightNumber}
                isLongStandingCustomer={isLongStandingCustomer}
            />
            <CrewMembersDetails crewMembers={itineraryLeg.crewMembers} />
            <Airports airports={itineraryLeg.airports} />
            <PassengerDetails passengers={itineraryLeg.passengers} />
            <Catering catering={itineraryLeg.additionalInformation && itineraryLeg.additionalInformation.catering} />
            <OtherInformation additionalInformation={itineraryLeg.additionalInformation} flightManager={itineraryLeg.flightManager} />
            <OptionalServices additionalInformation={itineraryLeg.additionalInformation} />
        </CollapsableSet>
    );
};
